import { render, staticRenderFns } from "./SurveyEditor.vue?vue&type=template&id=b3803606&"
import script from "./SurveyEditor.vue?vue&type=script&lang=ts&"
export * from "./SurveyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports